import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useShowContractTerms(isAgent: boolean): boolean {
  const shouldShowContractTerms = useCbhFlag(CbhFeatureFlag.SHOULD_SHOW_CONTRACT_TERMS, {
    defaultValue: false,
  });
  return shouldShowContractTerms && !isAgent;
}
